import { render, staticRenderFns } from "./edit-pertanyaan.vue?vue&type=template&id=592d102b&"
import script from "./edit-pertanyaan.vue?vue&type=script&lang=js&"
export * from "./edit-pertanyaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports